export default "__VITE_ASSET__BFsDVsvF__"